import { DEFAULT_THEME, createTheme } from "@mantine/core";
import { css } from "@emotion/react";

const primaryColors = [
  "#A8FAD3", // 1 - lighter
  "#7CF7BC", // 2 - light
  "#4EF4A6", // 3
  "#36F49C", // 4
  "#25F290", // 5
  "#2DB976", // 6 - medium
  "#2DB976", // 7 - base
  "#08B964", // 8
  "#079F57", // 9
  "#05854A", // 10
];

const secondaryColors = [
  "#ECECF1", // 0
  "#D1D2DA", // 1 - very light
  "#B6B8C4", // 2
  "#A3A5B5", // 3 - lighter
  "#8E90A3", // 4
  "#75778F", // 5 - light
  "#5D5E7A", // 6
  "#474A6A", // 7 - medium
  "#303559", // 8
  "#191D4A", // 9 - base
];

const redColors = [
  "#FFE3E3",
  "#FFBDBD",
  "#FF9B9B",
  "#F86A6A",
  "#EF4E4E",
  "#E12D39", //5
  "#CF1124",
  "#AB091E",
  "#8A041A",
  "#610316",
];

export const rootGlobalStyles = css`
  :root[data-mantine-color-scheme="light"] {
    --text-color: var(--mantine-color-secondary-9);
    --mantine-color-text: var(--mantine-color-secondary-9);
    --text-fz: var(--mantine-font-size-sm);
  }
  .upload-border-color {
    border-color: var(--mantine-color-primary-6);
  }
  .upload-border-color svg {
    color: var(--mantine-color-primary-6);
  }
  .upload-text-color {
    color: var(--mantine-color-primary-6);
  }
  .asterisk,
  .text-error {
    color: var(--mantine-color-error);
  }
  .mantine-CloseButton-root:hover {
    background-color: var(--mantine-color-primary-0);
  }
  .mantine-InputClearButton-root:hover {
    background-color: var(--mantine-color-primary-0);
  }
  .mantine-DateInput-section[data-position="left"] {
    color: var(--mantine-color-primary-filled);
  }
  .fallback-image-icon {
    color: var(--mantine-color-primary-filled);
  }
  .mantine-Modal-content {
    will-change: auto !important;
  }
`;

export const rootTheme = createTheme({
  ...DEFAULT_THEME,
  colors: {
    ...DEFAULT_THEME.colors,
    primary: primaryColors,
    secondary: secondaryColors,
    red: redColors,
  },
  primaryColor: "primary",
  fontFamily: `"Roboto", -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, sans-serif`,
  spacing: {
    xs: "6px",
    sm: "10px",
    md: "16px",
    lg: "24px",
    xl: "32px",
  },
  fontSizes: {
    xs: "12px",
    sm: "14px",
    md: "18px",
    lg: "24px",
    xl: "28px",
  },
  radius: { sm: "6px", md: "10px", lg: "14px" },
  components: {
    ...DEFAULT_THEME.components,
    CloseButton: {
      styles: (theme) => ({
        root: {
          color: theme.colors.secondary[9],
        },
      }),
    },
    Tooltip: {
      styles: (theme) => ({
        tooltip: {
          backgroundColor: theme.colors.secondary[9],
          color: theme.colors.primary[6],
        },
      }),
    },
    Dropzone: {
      styles: (theme) => ({
        root: {
          color: theme.colors.primary[6],
          borderColor: theme.colors.primary[6],
        },
      }),
    },
    Notification: {
      styles: () => ({
        root: {
          "--notification-color": "var(--mantine-color-error)",
        },
      }),
    },
    ScrollArea: {
      defaultProps: {
        scrollbarSize: 6,
        type: "always",
      },
      styles: (theme) => ({
        thumb: {
          width: 4,
          backgroundColor: theme.colors.primary[6],
          borderRadius: 8,
        },
        scrollbar: {
          background: "transparent",
        },
      }),
    },
    Select: {
      defaultProps: {
        scrollAreaProps: { type: "always" },
      },
    },
    MultiSelect: {
      defaultProps: {
        scrollAreaProps: { type: "always" },
      },
    },
    Autocomplete: {
      defaultProps: {
        scrollAreaProps: { type: "always" },
      },
    },
    TagsInput: {
      defaultProps: {
        scrollAreaProps: { type: "always" },
      },
    },
    Table: {
      styles: (theme) => ({
        th: {
          backgroundColor: theme.colors.gray[2],
        },
      }),
    },
    Pagination: {
      styles: (theme) => ({
        control: {
          border: "none",
          fontSize: theme.fontSizes.sm,
        },
      }),
    },
    Button: {
      styles: {
        label: {
          letterSpacing: 1,
          textTransform: "uppercase",
        },
      },
    },
    Modal: {
      styles: (theme) => ({
        header: {
          backgroundColor: theme.colors.gray[3],
          marginBottom: theme.spacing.md,
        },
        title: {
          fontSize: "1.25rem",
          fontWeight: 700,
          color: theme.colors.secondary[8],
        },
      }),
    },
  },
});
